import { useQuery } from "@tanstack/react-query";
import { ApiGetInviteLevelConfig } from "@/api";

export const useInviteLevelConfig = (coinContract: string) => {
  return useQuery({
    queryKey: ["inviteLevelConfig", coinContract],
    queryFn: async () => {
      const res = await ApiGetInviteLevelConfig({ coinContract });
      console.log(res, "inviteLevelConfig");
      return res.data;
    },
    enabled: Boolean(coinContract?.trim()),
  });
};
